let locales = {
    sv : {
        SHOP_NOW_URL: 'handla-nu',
        SHOP_NOW_TEST_URL: 'shop-now-new',
        BUNDLES_URL: 'bundles',
        BUNDLES_TEST_URL: 'bundles-new',
        BUNDLES_AND_PRODUCTS_URL: 'shop-with-bundles',
        BUNDLES_AND_PRODUCTS_TEST_URL: 'shop-with-bundles-new'
    },
    no : {
        SHOP_NOW_URL: 'handle-na',
        SHOP_NOW_TEST_URL: 'shop-now-new',
        BUNDLES_URL: 'bundles',
        BUNDLES_TEST_URL: 'bundles-new',
        BUNDLES_AND_PRODUCTS_URL: 'shop-with-bundles',
        BUNDLES_AND_PRODUCTS_TEST_URL: 'shop-with-bundles-new'
    }
}

function getLang()
{
    switch (currentLocale) {
        case 'sv':
            return locales.sv;
        case 'no':
            return locales.no;
        default:
            return locales.sv;
    }
}
